module.exports = __webpack_public_path__ + "81a95c674c3aef04a1fcfc2aa10cc720.png";